var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelemedicine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.391,
    height: 51.62,
    viewBox: "0 0 70.391 51.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12993",
    d: "M65.957 53.484a1.174 1.174 0 0 1-1.173-1.173V14.77a1.177 1.177 0 0 0-1.173-1.17H9.645a1.177 1.177 0 0 0-1.174 1.17v37.541a1.173 1.173 0 0 1-2.346 0V14.77a3.524 3.524 0 0 1 3.52-3.52h53.966a3.524 3.524 0 0 1 3.52 3.52v37.541a1.174 1.174 0 0 1-1.174 1.173z",
    transform: "translate(-1.432 -11.25)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12994",
    d: "M66.9 53.914H8.241a5.871 5.871 0 0 1-5.866-5.866 1.174 1.174 0 0 1 1.173-1.173h25.81a1.173 1.173 0 1 1 0 2.346H4.923a3.524 3.524 0 0 0 3.318 2.346H66.9a3.524 3.524 0 0 0 3.318-2.346H45.783a1.173 1.173 0 0 1 0-2.346h25.81a1.174 1.174 0 0 1 1.173 1.173 5.871 5.871 0 0 1-5.866 5.866z",
    transform: "translate(-2.375 -2.294)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12995",
    d: "M27.8 21h10.18v6.8h6.8v10.18h-6.8v6.8H27.8v-6.8H21V27.8h6.8z",
    transform: "translate(2.307 -8.799)",
    style: {
      fill: "none",
      stroke: "#d24350",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelemedicine);
export default __webpack_public_path__ + "static/media/telemedicine.b294571c9f621e53d2bc862ba74714a3.svg";
export { ForwardRef as ReactComponent };